import ThumbnailImage, { ThumbnailImageInit } from './ThumbnailImage';

export interface CourseInit {
  id: number;
  publicId: number;
  duration?: number;
  blockingDuration?: number;
  price?: number;
  onsitePrice?: number;
  name: string;
  image?: ThumbnailImageInit;
  description: string;
}

export default class Course {
  public readonly id: number;
  public readonly publicId: number;
  public readonly duration?: number;
  public readonly blockingDuration?: number;
  public readonly price?: number;
  public readonly onsitePrice?: number;
  public readonly name: string;
  public readonly image?: ThumbnailImage;
  public readonly description: string;

  constructor(init: CourseInit) {
    this.id = init.id;
    this.publicId = init.publicId;
    this.duration = init.duration;
    this.blockingDuration = init.blockingDuration;
    this.price = init.price;
    this.onsitePrice = init.onsitePrice;
    this.name = init.name;
    this.image = init.image ? new ThumbnailImage(init.image) : undefined;
    this.description = init.description;
  }
}
